module.exports = __webpack_public_path__ + "img/logo04.f8dcbec.jpg";